"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const api_external_contract_js_1 = require("@tableau/api-external-contract-js");
const ServiceRegistry_1 = require("../Services/ServiceRegistry");
const ErrorHelpers_1 = require("../Utils/ErrorHelpers");
class Filter {
    constructor(_worksheetName, _fieldName, _filterType, _fieldId, _registryId) {
        this._worksheetName = _worksheetName;
        this._fieldName = _fieldName;
        this._filterType = _filterType;
        this._fieldId = _fieldId;
        this._registryId = _registryId;
    }
    get worksheetName() {
        return this._worksheetName;
    }
    get fieldName() {
        return this._fieldName;
    }
    get fieldId() {
        return this._fieldId;
    }
    get filterType() {
        return this._filterType;
    }
    getFieldAsync() {
        const service = ServiceRegistry_1.ApiServiceRegistry.get(this._registryId).getService("data-source-service" /* DataSourceService */);
        return service.getFieldAsync(this._fieldId);
    }
    getAppliedWorksheetsAsync() {
        const service = ServiceRegistry_1.ApiServiceRegistry.get(this._registryId).getService("filter-service" /* Filter */);
        return service.getAppliedWorksheetsAsync(this._worksheetName, this._fieldId);
    }
    setAppliedWorksheetsAsync(applyToWorksheets) {
        ErrorHelpers_1.ErrorHelpers.verifyParameter(applyToWorksheets, 'applyToWorksheets');
        const uniqueWorksheets = new Set(applyToWorksheets);
        const service = ServiceRegistry_1.ApiServiceRegistry.get(this._registryId).getService("filter-service" /* Filter */);
        return service.setAppliedWorksheetsAsync(this._worksheetName, this._fieldName, this._fieldId, Array.from(uniqueWorksheets));
    }
}
exports.Filter = Filter;
class CategoricalFilter extends Filter {
    constructor(worksheetName, fieldName, fieldId, filterType, registryId, _appliedValues, _isExcludeMode, _isAllSelected) {
        super(worksheetName, fieldName, filterType, fieldId, registryId);
        this._appliedValues = _appliedValues;
        this._isExcludeMode = _isExcludeMode;
        this._isAllSelected = _isAllSelected;
    }
    get isAllSelected() {
        return this._isAllSelected;
    }
    get appliedValues() {
        return this._appliedValues;
    }
    get isExcludeMode() {
        return this._isExcludeMode;
    }
    getDomainAsync(domainType) {
        if (!domainType) {
            domainType = api_external_contract_js_1.FilterDomainType.Relevant;
        }
        ErrorHelpers_1.ErrorHelpers.verifyEnumValue(domainType, api_external_contract_js_1.FilterDomainType, 'FilterDomainType');
        const service = ServiceRegistry_1.ApiServiceRegistry.get(this._registryId).getService("filter-service" /* Filter */);
        return service.getCategoricalDomainAsync(this._worksheetName, this._fieldId, domainType);
    }
}
exports.CategoricalFilter = CategoricalFilter;
class HierarchicalDataValue {
    constructor(_value, _hierarchicalPath, _level) {
        this._value = _value;
        this._hierarchicalPath = _hierarchicalPath;
        this._level = _level;
    }
    get value() {
        return this._value;
    }
    get hierarchicalPath() {
        return this._hierarchicalPath;
    }
    get level() {
        return this._level;
    }
}
exports.HierarchicalDataValue = HierarchicalDataValue;
class HierarchicalLevelDetail {
    constructor(_name, _levelSelectionState) {
        this._name = _name;
        this._levelSelectionState = _levelSelectionState;
    }
    get name() {
        return this._name;
    }
    get levelSelectionState() {
        return this._levelSelectionState;
    }
}
exports.HierarchicalLevelDetail = HierarchicalLevelDetail;
class HierarchicalFilter extends Filter {
    constructor(worksheetName, fieldName, fieldId, filterType, registryId, _dimensionName, _hierarchyCaption, _numberOfLevels, _levelDetails, _appliedValues, _isAllSelected) {
        super(worksheetName, fieldName, filterType, fieldId, registryId);
        this._dimensionName = _dimensionName;
        this._hierarchyCaption = _hierarchyCaption;
        this._numberOfLevels = _numberOfLevels;
        this._levelDetails = _levelDetails;
        this._appliedValues = _appliedValues;
        this._isAllSelected = _isAllSelected;
    }
    getDomainAsync(domainType) {
        throw new Error('Method not implemented.');
    }
    get dimensionName() {
        return this._dimensionName;
    }
    get hierarchyCaption() {
        return this._hierarchyCaption;
    }
    get numberOfLevels() {
        return this._numberOfLevels;
    }
    get levelDetails() {
        return this._levelDetails;
    }
    get isAllSelected() {
        return this._isAllSelected;
    }
    get appliedValues() {
        return this._appliedValues;
    }
}
exports.HierarchicalFilter = HierarchicalFilter;
class RangeFilter extends Filter {
    constructor(worksheetName, fieldName, fieldId, filterType, registryId, _min, _max, _includeNullValues) {
        super(worksheetName, fieldName, filterType, fieldId, registryId);
        this._min = _min;
        this._max = _max;
        this._includeNullValues = _includeNullValues;
    }
    get minValue() {
        return this._min;
    }
    get maxValue() {
        return this._max;
    }
    get includeNullValues() {
        return this._includeNullValues;
    }
    getDomainAsync(domainType) {
        const service = ServiceRegistry_1.ApiServiceRegistry.get(this._registryId).getService("filter-service" /* Filter */);
        if (!domainType) {
            domainType = api_external_contract_js_1.FilterDomainType.Relevant;
        }
        ErrorHelpers_1.ErrorHelpers.verifyEnumValue(domainType, api_external_contract_js_1.FilterDomainType, 'FilterDomainType');
        return service.getRangeDomainAsync(this._worksheetName, this._fieldId, domainType);
    }
}
exports.RangeFilter = RangeFilter;
class RelativeDateFilter extends Filter {
    constructor(worksheetName, fieldName, fieldId, filterType, registryId, _anchorDate, _periodType, _rangeType, _rangeN) {
        super(worksheetName, fieldName, filterType, fieldId, registryId);
        this._anchorDate = _anchorDate;
        this._periodType = _periodType;
        this._rangeType = _rangeType;
        this._rangeN = _rangeN;
    }
    get anchorDate() {
        return this._anchorDate;
    }
    get periodType() {
        return this._periodType;
    }
    get rangeType() {
        return this._rangeType;
    }
    get rangeN() {
        return this._rangeN;
    }
}
exports.RelativeDateFilter = RelativeDateFilter;
class CategoricalDomain {
    constructor(_values, _domainType) {
        this._values = _values;
        this._domainType = _domainType;
    }
    get values() {
        return this._values;
    }
    get type() {
        return this._domainType;
    }
}
exports.CategoricalDomain = CategoricalDomain;
class RangeDomain {
    constructor(_min, _max, _domainType) {
        this._min = _min;
        this._max = _max;
        this._domainType = _domainType;
    }
    get type() {
        return this._domainType;
    }
    get min() {
        return this._min;
    }
    get max() {
        return this._max;
    }
}
exports.RangeDomain = RangeDomain;
//# sourceMappingURL=FilterModels.js.map